import '../../assets/styles/auth.scss'
import logo from '../../assets/images/logo/logo.svg'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import henceforthApi, { GOOGLE_API_KEY } from '../../utils/henceforthApi';
import loginSuccess from '../../context/actions/auth/loginSuccess';
import { Fragment, useContext, useState, useRef, useEffect } from 'react';
import { GlobalContext, handleError } from '../../context/Provider';
import { strongPasswordValidation, validateEmail } from '../../utils/validations';
import Spinner from '../../components/common/spinner';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css'
import Errormessage from '../../components/common/errormessage';
import Svg from "../../components/common/error-svg"
import { requestNotification } from '../../utils/firebase';
import VerifyOtp from '../../components/modals/VerifyEmailOtp';
import henceofrthEnums from '../../utils/henceofrthEnums';
import { isValidPhoneNumber } from 'libphonenumber-js'

interface DocumentType {
  type: string;
  front_image: File | null;
  back_image: File | null;
}

interface DocumentConfig {
  type: string;
  label: string;
}

const Signup = () => {
  const navigate = useNavigate()
  const [firstEye, setFirstEye] = useState(true);
  const { authDispatch, toastMessage, loading, setLoading, language_data, authState } = useContext(GlobalContext);

  // Step management
  const [currentStep, setCurrentStep] = useState(1);

  // Step 1 errors
  const [nameErr, setNameErr] = useState('')
  const [emailErr, setEmailErr] = useState('')
  const [phoneErr, setPhoneErr] = useState('')
  const [passwordEr, setPasswordEr] = useState('')
  const [countryIsoCode, setCountryIsoCode] = useState('gm')

  // Step 2 errors
  const [companyErr, setCompanyErr] = useState('')
  const [addressErr, setAddressErr] = useState('')

  // Step 3 errors
  const [documentTypeErr, setDocumentTypeErr] = useState('')
  const [frontImageErr, setFrontImageErr] = useState('')
  const [backImageErr, setBackImageErr] = useState('')

  const [checkboxEr, setCheckboxEr] = useState('')
  const [checkbox, setcheckbox] = useState(false)
  const [openEmailVerification, setOpenEmailVerification] = useState<boolean>(false)

  const [state, setState] = useState({
    name: "",
    email: "",
    country_code: "220",
    phone_number: "",
    password: "",
    company: "",
    country: "",
    state: "",
    city: "",
    pin_code: "",
    apartment_number: "",
    full_address: "",
    lat: "",
    lng: "",
    loading: false,
  });

  // Document state - array of documents
  const [documents, setDocuments] = useState<DocumentType[]>([]);

  // Document types from API
  const [documentTypes, setDocumentTypes] = useState<DocumentConfig[]>([]);
  const fetchDocumentTypes = async () => {
    try {
      const response = await henceforthApi.Auth.getDocumentTypes();
      if (response && response.data && Array.isArray(response.data)) {
        setDocumentTypes(response.data);
      } else {
        setDocumentTypes([
          { type: 'aadhar_card', label: 'Aadhar Card' },
          { type: 'pan_card', label: 'PAN Card' }
        ]);
      }
    } catch (error) {
      console.error('Error fetching document types:', error)
      setDocumentTypes([
        { type: 'aadhar_card', label: 'Aadhar Card' },
        { type: 'pan_card', label: 'PAN Card' }
      ]);
    }
  };

  // Fetch document types from API on component mount
  useEffect(() => {
    fetchDocumentTypes();
  }, []);

  const [store, setStore] = useState({} as any)
  const placeInputRef = useRef(null) as React.MutableRefObject<any>

  // Validation for Step 1
  const validateStep1 = (): boolean => {
    let isValid = true;

    if (!state.name.trim()) {
      setNameErr("Please provide valid name");
      isValid = false;
    }
    if (!state.email) {
      setEmailErr("Please fill email");
      isValid = false;
    } else if (!validateEmail(state.email)) {
      setEmailErr("Please fill valid email");
      isValid = false;
    }
    if (!state.phone_number.trim()) {
      setPhoneErr("Phone is required");
      isValid = false;
    } else {
      const fullNumber = `+${state.country_code}${state.phone_number}`
      try {
        const valid = countryIsoCode
          ? isValidPhoneNumber(fullNumber, countryIsoCode.toUpperCase() as any)
          : isValidPhoneNumber(fullNumber)
        if (!valid) {
          setPhoneErr("Please provide valid number");
          isValid = false;
        }
      } catch {
        setPhoneErr("Please provide valid number");
        isValid = false;
      }
    }
    if (!state.password.trim()) {
      setPasswordEr("Password is required");
      isValid = false;
    } else if (!strongPasswordValidation(state.password)) {
      setPasswordEr("Password must be atleast 8 character long and contain one uppercase and one lowercase characters with special characters and numbers");
      isValid = false;
    }

    return isValid;
  };

  // Validation for Step 2
  const validateStep2 = (): boolean => {
    let isValid = true;

    if (!state.company.trim()) {
      setCompanyErr("Company name is required");
      isValid = false;
    }
    if (!state.full_address.trim()) {
      setAddressErr("Address is required");
      isValid = false;
    }

    return isValid;
  };

  // Initialize documents when documentTypes are loaded
  useEffect(() => {
    if (documentTypes.length > 0) {
      const initialDocuments: DocumentType[] = documentTypes.map(doc => ({
        type: doc.type,
        front_image: null,
        back_image: null
      }));
      setDocuments(initialDocuments);
    }
  }, [documentTypes]);

  // Validation for Step 3
  const validateStep3 = (): boolean => {
    let isValid = true;

    // Validate all documents
    documents.forEach((doc, index) => {
      if (!doc.front_image) {
        setFrontImageErr(`Please upload ${documentTypes[index]?.label} front image`);
        isValid = false;
      }
      if (!doc.back_image) {
        setBackImageErr(`Please upload ${documentTypes[index]?.label} back image`);
        isValid = false;
      }
    });

    if (!checkbox) {
      setCheckboxEr("Please agree to terms and condition");
      isValid = false;
    }

    return isValid;
  };

  // Navigate to next step
  const nextStep = () => {
    if (currentStep === 1 && validateStep1()) {
      setCurrentStep(2);
    } else if (currentStep === 2 && validateStep2()) {
      setCurrentStep(3);
    }
  };

  // Navigate to previous step
  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };
  const submitForm = async (e: any) => {
    e.preventDefault();

    if (!validateStep3()) return;

    setState({
      ...state,
      loading: true,
    });

    let fcmid = await requestNotification()
    const { name, email, country_code, phone_number, password, country, state: stateVal, city, pin_code, apartment_number, full_address, lat, lng } = state;

    let items = {
      name: name,
      email: email,
      country_code: country_code,
      phone_number: phone_number,
      password: password,
      company: state.company,
      country: country,
      state: stateVal,
      city: city,
      pin_code: pin_code,
      apartment_number: apartment_number,
      full_address: full_address,
      lat: lat,
      lng: lng,
      language: "ENGLISH",
    } as any;

    if (fcmid) items['fcm_token'] = fcmid

    try {
      // Upload all documents
      const uploadedDocuments = await Promise.all(
        documents.map(async (doc) => {
          let frontKey = '';
          let backKey = '';

          if (doc.front_image) {
            const frontUploadRes = await henceforthApi.Common.do_spaces_file_upload('file', doc.front_image);
            frontKey = frontUploadRes.data.file_name;
          }

          if (doc.back_image) {
            const backUploadRes = await henceforthApi.Common.do_spaces_file_upload('file', doc.back_image);
            backKey = backUploadRes.data.file_name;
          }

          return {
            type: doc.type,
            images: {
              front: frontKey,
              back: backKey
            }
          };
        })
      );

      // Add documents array to items
      items.documents = uploadedDocuments;

      let res = await henceforthApi.Auth.signup(items)
      setStore(res.data)
      toastMessage("SignUp Successfully");
      setOpenEmailVerification(true)
    }
    catch (err) {
      handleError(err, 'active', authDispatch);
    }
    finally {
      setState({
        ...state,
        loading: false,
      });
    }
  };
  const changeHanlder = (e: any) => {
    let name = e.target.name;
    let value = e.target.value;
    setState({
      ...state,
      [name]: value,
    });
  };

  const phoneCheck = (e: any, v: any) => {
    setPhoneErr('')
    setCountryIsoCode(v.countryCode || '')  // "gm", "us" etc
    setState({
      ...state,
      phone_number: e.phone.slice(Number(v.dialCode.length), Number(e.phone.length)),
      country_code: v.dialCode,
    });
  }
  henceforthApi.setToken(store.access_token)
  const initialiseProfile = async (data: any) => {
    try {
      let apiRes = await henceforthApi.Auth.emailVerifyOtp({ otp: data, language: 'ENGLISH' })
      console.log('apiRes', apiRes);
      // Login the user successfully with the API response
      loginSuccess({ ...apiRes.data, lang: henceofrthEnums.Language.ENGLISH })(authDispatch);
      henceforthApi.languageChange(henceofrthEnums.Language.ENGLISH)
      setOpenEmailVerification(false)
      // Navigate directly to dashboard after successful verification
      navigate(`/`)
      toastMessage("Email verified successfully! Welcome to dashboard.")

    } catch (err) {
      handleError(err, 'active', authDispatch)
    }

  }
  const resendEmailOtp = async () => {
    if (loading) return
    setLoading(true)
    try {
      let items = {
        email: state.email,
        language: "ENGLISH"
      }
      let apiRes = await henceforthApi.Auth.emailVerifySendOtp(items)
      return apiRes.data
    } catch (error: any) {
      handleError(error, 'active', authDispatch)
    } finally {
      setLoading(false)
    }
  }

  // Load Google Maps script
  function loadGoogleMapScript(callback: any) {
    if (
      typeof (window as any).google === "object" &&
      typeof (window as any).google.maps === "object"
    ) {
      callback();
    } else {
      const googleMapScript = document.createElement("script");
      googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_API_KEY}&libraries=places`;
      window.document.body.appendChild(googleMapScript);
      googleMapScript.addEventListener("load", callback);
    }
  }

  // Initialize Google Places Autocomplete
  const initPlaceAPI = () => {
    if (!placeInputRef.current) return;

    loadGoogleMapScript(() => {
      if (placeInputRef.current) {
        // Check if autocomplete is already initialized
        const existingAutocomplete = (window as any).google.maps.places?.Autocomplete?.instance;

        let autocomplete = new (window as any).google.maps.places.Autocomplete(
          placeInputRef.current,
          {
            types: ['address'],
            componentRestrictions: { country: 'in' } // Optional: Restrict to India
          }
        );

        autocomplete.addListener("place_changed", () => {
          let place = autocomplete.getPlace();

          let formatAddress = place.formatted_address || '';
          let lat = place.geometry?.location?.lat() || '';
          let lng = place.geometry?.location?.lng() || '';

          const address = place.address_components;

          let items: any = {};

          if (Array.isArray(address)) {
            address.forEach((comp: any) => {
              if (comp.types.includes("postal_code")) {
                items.pin_code = comp.long_name;
              }
              if (comp.types.includes("administrative_area_level_1")) {
                items.state = comp.long_name;
              }
              if (comp.types.includes("administrative_area_level_2")) {
                items.city = comp.long_name;
              }
              if (comp.types.includes("locality")) {
                items.city = comp.long_name;
              }
              if (comp.types.includes("country")) {
                items.country = comp.short_name;
              }
              if (comp.types.includes("street_number")) {
                items.apartment_number = comp.long_name;
              }
              if (comp.types.includes("route")) {
                if (!items.apartment_number) {
                  items.apartment_number = comp.long_name;
                }
              }
            });
          }

          setState((prev) => ({
            ...prev,
            country: items.country || "",
            state: items.state || "",
            city: items.city || "",
            pin_code: items.pin_code || "",
            apartment_number: items.apartment_number || "",
            full_address: formatAddress,
            lat: String(lat),
            lng: String(lng),
          }));

          // Clear errors
          setAddressErr('');
        });
      }
    });
  };

  useEffect(() => {
    // Initialize Google Places API when Step 2 is reached
    if (currentStep === 2 && placeInputRef.current) {
      initPlaceAPI();
    }
  }, [currentStep]);
  const onCloseModal = (close: boolean) => {
    setOpenEmailVerification(close)
    // Navigate to signin only if user closes the modal without verifying
    toastMessage("Please verify your email to continue.")
    navigate('/signin')
  }

  // Alternative close handler that navigates to dashboard
  const onCloseModalToDashboard = () => {
    setOpenEmailVerification(false)
    // After successful verification, user is already logged in, go to dashboard
    navigate('/')
  }
  return (
    <Fragment>
      <section className='auth-pages'>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xxl-4 col-xl-5 col-lg-6 col-md-7 col-sm-10">
              <div className="auth-page-card mb-4">
                {/* logo */}
                <div className='auth-logo-box text-center'>
                  <img src={logo} width={200} alt="img" />
                </div>
                {/* title  */}
                <div className='auth-page-card-title text-center my-4'>
                  <h3 className='mb-2'>Register to Yonna Ecommerce</h3>
                  <p>Create account to see it in action.</p>
                </div>

                {/* Step Indicators */}
                <div className="step-indicators mb-4">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className={`step ${currentStep >= 1 ? 'active' : ''}`}>
                      <div className="step-circle">{currentStep > 1 ? '✓' : '1'}</div>
                      <small>Personal Info</small>
                    </div>
                    <div className={`step-line ${currentStep > 1 ? 'active' : ''}`}></div>
                    <div className={`step ${currentStep >= 2 ? 'active' : ''}`}>
                      <div className="step-circle">{currentStep > 2 ? '✓' : '2'}</div>
                      <small>Company Info</small>
                    </div>
                    <div className={`step-line ${currentStep > 2 ? 'active' : ''}`}></div>
                    <div className={`step ${currentStep >= 3 ? 'active' : ''}`}>
                      <div className="step-circle">3</div>
                      <small>Documents</small>
                    </div>
                  </div>
                </div>

                {/* form  */}
                <form onSubmit={submitForm} >
                  {/* Step 1: Personal Information */}
                  {currentStep === 1 && (
                    <Fragment>
                      <h5 className="mb-3">Personal Information</h5>
                      {/* Name  */}
                      <div className='form-fields-box mb-3'>
                        <input type="text" className={`form-control rounded-0 ${nameErr && state.name === '' ? 'is-invalid' : ''}`} placeholder="Name" name='name' value={state.name} onChange={(e: any) => { setNameErr(''); changeHanlder(e); }} maxLength={30} />
                        <Errormessage class={nameErr && state.name === '' ? nameErr : ''} error={nameErr && state.name === '' ? nameErr : ''} />
                      </div>
                      {/* Email  */}
                      <div className='form-fields-box mb-3'>
                        <input type="text" className={`form-control rounded-0 mb-2 ${emailErr ? 'is-invalid' : ''}`} placeholder="Email" name='email' value={state.email} onChange={(e: any) => { setEmailErr(''); changeHanlder(e); }} />
                        <Errormessage class={emailErr} error={emailErr} />
                      </div>
                      {/* Phone Number  */}
                      <div className={`form-fields-box mb-2 is-invalid rounded-0 ${phoneErr ? 'border border-danger position-relative' : ""}`}>
                        <PhoneInput country={'gm'} disableDropdown={true} value={state.country_code + state.phone_number} onChange={(phone: any, value: any) => { phoneCheck({ phone }, value) }} />
                        {phoneErr ? <span className='svg-question'><Svg /></span> : ''}
                      </div>
                      <Errormessage phone={phoneErr} error={phoneErr} />
                      {/* Password  */}
                      <div className={`form-fields-box mb-3 ${phoneErr ? '' : 'mt-3'}`}>
                        <div className="input-group is-invalid">
                          <input type={firstEye ? "password" : "text"}
                            name='password' onChange={(e: any) => { setPasswordEr(''); changeHanlder(e); }}
                            value={state.password}
                            className={`form-control rounded-0 ${passwordEr ? 'is-invalid' : ''}`} placeholder="Password" />
                          <div className="input-group-append">
                            <span className={`input-group-text group-btn-span ${passwordEr ? 'border border-danger' : ''}`} onClick={() => setFirstEye(!firstEye)}> <i
                              className={`fa ${firstEye ? `fa-eye ${passwordEr ? 'text-danger' : 'text-secondary'}` : `fa-eye-slash ${passwordEr ? 'text-danger' : 'text-secondary'}`}`}
                              aria-hidden="true"
                            ></i></span>
                          </div>
                        </div>
                        <Errormessage class={passwordEr} error={passwordEr} />
                      </div>
                      {/* Next Button */}
                      <div className='form-fields-box mt-4'>
                        <button type='button' className='btn btn-theme w-100' onClick={nextStep}>
                          Next <i className="fa fa-arrow-right ms-2"></i>
                        </button>
                      </div>
                    </Fragment>
                  )}

                  {/* Step 2: Company Information */}
                  {currentStep === 2 && (
                    <Fragment>
                      <h5 className="mb-3">Company Information</h5>
                      {/* Company Name */}
                      <div className='form-fields-box mb-3'>
                        <input type="text" className={`form-control rounded-0 ${companyErr ? 'is-invalid' : ''}`} placeholder="Company Name" name='company' value={state.company} onChange={(e: any) => { setCompanyErr(''); changeHanlder(e); }} maxLength={50} />
                        <Errormessage class={companyErr} error={companyErr} />
                      </div>
                      {/* Address with Google Autocomplete */}
                      <div className='form-fields-box mb-3'>
                        <input
                          ref={placeInputRef}
                          type="text"
                          className={`form-control rounded-0 ${addressErr ? 'is-invalid' : ''}`}
                          placeholder="Address (Start typing to autocomplete)"
                          name='full_address'
                          value={state.full_address}
                          onChange={(e: any) => { setAddressErr(''); changeHanlder(e); }}
                          maxLength={200}
                        />
                        <Errormessage class={addressErr} error={addressErr} />
                      </div>
                      {/* Navigation Buttons */}
                      <div className='d-flex gap-2 mt-4'>
                        <button type='button' className='btn btn-secondary flex-fill' onClick={prevStep}>
                          <i className="fa fa-arrow-left me-2"></i> Back
                        </button>
                        <button type='button' className='btn btn-theme flex-fill' onClick={nextStep}>
                          Next <i className="fa fa-arrow-right ms-2"></i>
                        </button>
                      </div>
                    </Fragment>
                  )}

                  {/* Step 3: Document Upload */}
                  {currentStep === 3 && (
                    <Fragment>
                      <h5 className="mb-3">Document Upload</h5>

                      {/* Render all document types */}
                      {documents.map((doc, index) => (
                        <div key={doc.type} className="mb-4">
                          <h6 className="fw-bold  mb-3">{documentTypes[index]?.label}</h6>
                          <div className='form-fields-box mb-3'>
                            <label className="fw-bold mb-2">Front Image</label>
                            <input
                              type="file"
                              className={`form-control rounded-0 ${frontImageErr && !doc.front_image ? 'is-invalid' : ''}`}
                              accept="image/*"
                              onChange={(e: any) => {
                                setFrontImageErr('');
                                const updatedDocs = [...documents];
                                updatedDocs[index].front_image = e.target.files[0];
                                setDocuments(updatedDocs);
                              }}
                            />
                            <p className='mt-1'><small>Upload front side of {documentTypes[index]?.label} (.jpg, .png)</small></p>
                            {frontImageErr && !doc.front_image && <Errormessage class={frontImageErr} error={frontImageErr} />}
                          </div>
                          <div className='form-fields-box mb-3'>
                            <label className="fw-bold mb-2">Back Image</label>
                            <input
                              type="file"
                              className={`form-control rounded-0 ${backImageErr && !doc.back_image ? 'is-invalid' : ''}`}
                              accept="image/*"
                              onChange={(e: any) => {
                                setBackImageErr('');
                                const updatedDocs = [...documents];
                                updatedDocs[index].back_image = e.target.files[0];
                                setDocuments(updatedDocs);
                              }}
                            />
                            <p className='mt-1'><small>Upload back side of {documentTypes[index]?.label} (.jpg, .png)</small></p>
                            {backImageErr && !doc.back_image && <Errormessage class={backImageErr} error={backImageErr} />}
                          </div>
                        </div>
                      ))}
                      {/* Terms and Conditions  */}
                      <div className='form-checkbox-box auth-form-links mb-4'>
                        <div className="form-check is-invalid">
                          <input className={`form-check-input shadow-none rounded-0${checkboxEr ? "is-invalid border border-danger" : ""}`} type="checkbox" value="" id="flexCheckDefault" onChange={(e) => { setcheckbox(e.target.checked); setCheckboxEr('') }} />
                          <label className="form-check-label" htmlFor="flexCheckDefault">Agree to the <Link to="/terms">Terms & Conditions</Link> and <Link to="/privacy">Privacy Policy</Link>.</label>
                        </div>
                        <Errormessage class={checkboxEr} error={checkboxEr} />
                      </div>
                      {/* Navigation Buttons */}
                      <div className='d-flex gap-2'>
                        <button type='button' className='btn btn-secondary flex-fill' onClick={prevStep}>
                          <i className="fa fa-arrow-left me-2"></i> Back
                        </button>
                        <button type='submit' className='btn btn-theme flex-fill' disabled={state.loading}>
                          {state.loading ? <Spinner color={"text-white"} /> : 'Register'}
                        </button>
                      </div>
                    </Fragment>
                  )}
                </form>
              </div>
              {/* Have Account  */}
              <div className='have-account-box'>
                <div className='form-fields-box text-center mb-3'>
                  <p>Already have an account?</p>
                </div>
                {/* Login button  */}
                <div className='form-fields-box'>
                  <Link to="/signin" className='btn btn-white w-100'>Sign In</Link>
                </div>
              </div>
            </div>
          </div>
        </div >
      </section >
      {openEmailVerification &&
        <VerifyOtp verifyCallback={initialiseProfile} resendOtpCallback={resendEmailOtp} onCloseModal={onCloseModal} />
      }
    </Fragment>
  );
};

export default Signup;
